var spoiler_default = {
  "fontElementMap": "NM5yE",
  "hideText": "MAVJp",
  "onHoverText": "WW-rf",
  "hideBlock": "BdJPS",
  "smallBlur": "OkYoy",
  "mediumBlur": "tsZ93",
  "largeBlur": "_1sbYq",
  "hideBlock_gallery": "RostT",
  "overlay_gallery": "VBGrZ",
  "overlay": "rhT8S",
  "revealSpoilerBtn": "_0sq6c",
  "isMobile": "-A1qx",
  "onHoverBtn": "BfR5I",
  "spoilerWrapper": "acHtl",
  "spoilerDescription": "vt9Fu",
  "spoilerContainer": "-Phbb",
  "spoilerContainer_Gallery": "t-sC2",
  "spoiler-text-blur": "_1RBUw"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
